"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { io } from "socket.io-client";
import { createContext, useEffect, useState } from "react";
export const SocketContext = createContext(null);
export const SocketProvider = ({ children, uri, }) => {
    const [socket, setSocket] = useState(null);
    const connect = (url) => {
        setSocket(io(url, {
            withCredentials: true,
        }));
    };
    const disconnect = () => {
        socket?.disconnect();
        setSocket(null);
    };
    useEffect(() => {
        if (!uri) {
            console.error("No uri provided");
        }
        connect(uri);
        return () => {
            disconnect();
        };
    }, [uri]);
    return _jsx(SocketContext, { value: { socket, uri }, children: children });
};
